module.exports = __webpack_public_path__ + "images/icon_bilan.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/boutons/icon_bilan.svg
// module id = 404
// module chunks = 0